import { BadgeCheckIcon, BadgeXIcon } from 'lucide-react';
import React from 'react';

export default function VerifiedBusinessBadge({
  isVerified = false,
}: {
  isVerified?: boolean;
}) {
  return (
    <div className="w-fit p-3 gap-2 rounded-md flex items-center justify-center flex-wrap  border border-border">
      {isVerified ? (
        <BadgeCheckIcon className="siz-5 lg:size-8 text-green-600" />
      ) : (
        <BadgeXIcon className="siz-5 lg:size-8 text-yellow-600" />
      )}

      <p className="high-emphasis-text w-fit font-medium text-center">
        {isVerified ? 'Verified Business' : 'Unverified Business'}
      </p>
    </div>
  );
}
